import { Injectable } from '@angular/core';

import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as ShipmentPackagesActions from './shipment-packages.actions';
import { ShipmentPackagesServiceBase } from './../shipment-packages-service-base';

@Injectable()
export class ShipmentPackagesEffects {

    loadShipmentPackages = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentPackagesActions.loadShipmentPackages),
            switchMap(action =>
                this.service
                    .getShipmentPackages(action.shipmentId, action.query)
                    .pipe(
                        map(response =>
                            ShipmentPackagesActions.loadShipmentPackagesSuccess(
                                { shipmentPackages: response.data, pagination: response.meta }
                            )
                        ),
                        catchError(error => {
                            console.error(error);
                            return of(
                                ShipmentPackagesActions.loadShipmentPackagesFailure({
                                    error,
                                })
                            );
                        })
                    )
            )
        )
    );

    updateShipmentPackage$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ShipmentPackagesActions.updateShipmentPackage),
            switchMap(action =>
                this.service
                    .updateShipmentPackage(
                        action.shipment.id,
                        action.shipmentPackage.id,
                        action.shipmentPackage
                    )
                    .pipe(
                        map(shipmentPackage =>
                            ShipmentPackagesActions.updateShipmentPackageSuccess(
                                { shipmentPackage }
                            )
                        ),
                        catchError(error => {
                            console.log('Error', error);
                            return of(
                                ShipmentPackagesActions.updateShipmentPackageFailure(
                                    { error }
                                )
                            );
                        })
                    )
            )
        )
    );

    genericFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ShipmentPackagesActions.updateShipmentPackageFailure),
                map(error => {
                    this.toastr.error(
                        error.error.message || 'Please try again',
                        'Something went wrong'
                    );
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private service: ShipmentPackagesServiceBase,
        private toastr: ToastrService
    ) {}
}
